import ShineThinking from "./ShineThinking";

export default ShineThinking;